import React, { FC, useEffect, useState } from 'react';
import { Button, Form, Message } from '../../kit';
import api from '../../api';
import styles from './styles.module.scss';

const RegisterView: FC<{ title: string }> = ({ title }): JSX.Element => {
    const [ errors, setErrors ] = useState<any>({});
    const [ emailAddress, setEmailAddress ] = useState<string>('');
    const [ password, setPassword ] = useState<string>('');
    const [ reset, setReset ] = useState<boolean>(false);
    const [ sent, setSent ] = useState<boolean>(false);
    
    const login = (): void => {
        setErrors({});

        api.login(emailAddress, password, '').then((res) => {
            window.location.href = '/community';
        }).catch(() => {
            setErrors({ emailAddress: 'Verkeerde gegevens', password: 'Verkeerde gegevens' });
        });
    }

    const resetPassword = (): void => {
        if (emailAddress === '') {
            setErrors({ emailAddress: 'Vul je e-mailadres in' });
            return;
        } else {
            setErrors({});
        }

        api.resetPassword(emailAddress).then(() => {
            setReset(false);
            setSent(true);
        }).catch(() => {
            setErrors({ emailAddress: 'Verkeerde gegevens', password: 'Verkeerde gegevens' });
        });
    }

    useEffect(() => {
        if (localStorage.getItem('accessToken')) {
            window.location.href = '/community';
        }
    }, []);

    return (
        <div className={styles.registerForm}>
            <h3>{title}</h3>
            {sent && (
                <Message
                    type="success"
                    content="Er is een nieuw wachtwoord verzonden"
                />
            )}
            <Form.Input
                error={errors.emailAddress}
                label="E-mailadres"
                name="emailAddress"
                onChange={({ value }: any) => setEmailAddress(value)}
                required
                type="email"
                value={emailAddress}
            />
            {reset ? (
                <div className={styles.buttons}>
                    <Button
                        color="transparent"
                        label="Annuleren"
                        onClick={() => setReset(false)}
                    />
                    <Button
                        color="primary"
                        label="Wachtwoord opvragen"
                        onClick={() => resetPassword()}
                    />
                </div>
            ) : (<>
                <Form.Input
                    error={errors.password}
                    label="Wachtwoord"
                    name="password"
                    onChange={({ value }: any) => setPassword(value)}
                    required
                    type="password"
                    value={password}
                />
                <div className={styles.buttons}>
                    <Button
                        color="transparent"
                        label="Wachtwoord vergeten?"
                        onClick={() => setReset(true)}
                    />
                    <Button
                        color="primary"
                        label="Inloggen"
                        onClick={() => login()}
                    />
                </div>
            </>)}
        </div>
    );
}

export default RegisterView;
